var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodscolorchangeNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M827.3,443.3L708.7,324.7c-3-3-7.1-4.7-11.3-4.7H576v-64h48c8.8,0,16-7.2,16-16V80c0-8.8-7.2-16-16-16H272 c-8.8,0-16,7.2-16,16v160c0,8.8,7.2,16,16,16h48v64H198.6c-4.2,0-8.3,1.7-11.3,4.7L68.7,443.3c-3,3-4.7,7.1-4.7,11.3v370.7 c0,4.2,1.7,8.3,4.7,11.3l118.6,118.6c3,3,7.1,4.7,11.3,4.7h498.7c4.2,0,8.3-1.7,11.3-4.7l118.6-118.6c3-3,4.7-7.1,4.7-11.3V454.6 C832,450.4,830.3,446.3,827.3,443.3z M320,128h256v64H320V128z M384,256h128v64H384V256z M768,805.5L677.5,896h-459L128,805.5 v-331l90.5-90.5h459l90.5,90.5V805.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M608,512H288c-17.7,0-32,14.3-32,32v192c0,17.7,14.3,32,32,32h320c17.7,0,32-14.3,32-32V544 C640,526.3,625.7,512,608,512z M576,704H320V576h256V704z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1023.8,
    cy: 767.9,
    r: 64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1188.4,689.8c-18.9-47.2-46.9-90.2-82.4-126.5c-54.2-55.9-124.3-93.8-200.8-108.4c-4.3-0.8-8.5,2.1-9.3,6.4 c0,0,0,0,0,0c-0.1,0.5-0.1,1-0.1,1.5v49c0,3.7,2.6,7,6.2,7.8c60.2,13.4,115.2,44.1,158.2,88.4c60.4,61.9,93.8,146.4,91.6,231.8 c-0.8,31-26.8,56.2-58,56.2H929c-52.8,0-96.7,42.2-97.2,95c-0.5,53.1,42.1,96.5,95.2,97c0,0,0,0,0,0h1c18.9,0,22.9,15.3,23.7,20.1 s2,20.5-15.8,26.6c-33.5,11.5-68.7,17.4-104.1,17.3c-103,0-194.8-48.9-253.4-124.8c-1.5-2-3.9-3.1-6.4-3.1h-58.6c-4.4,0-8,3.6-8,8 c0,1.5,0.4,3,1.2,4.2c82.2,130.6,238.9,204,399.3,172.5c17.2-3.4,34.2-7.9,50.8-13.6c21.7-7.5,38.7-21.6,49-40.8 c18.9-35.9,11.5-80-18-107.9c-16-14.8-36.7-22.6-59.6-22.6h-0.3c-17.5,0-31.7-14-32-31.5c-0.3-17.9,14.7-32.5,32.6-32.5h165.5 c66.1,0.1,120.2-52.5,122-118.6C1217.2,789.5,1207.9,737.9,1188.4,689.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodscolorchangeNormal);
export default __webpack_public_path__ + "static/media/hp_goodscolorchange_normal.da10518fc82bb8ece821bdac911c1201.svg";
export { ForwardRef as ReactComponent };